module.exports = __webpack_public_path__ + "img/dataservice_zcry.99309d01.png";